import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89034542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-sm d-flex flex-column mt-5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Enviar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_CKEditorVue = _resolveComponent("CKEditorVue")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_card, { class: "mb-1" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_form, {
          autoComplete: "off",
          action: "",
          onKeydown: _withKeys(_withModifiers(_ctx.handleAddMessage, ["prevent"]), ["enter"]),
          "data-test": "loginBForm"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_b_form_group, {
                id: "message",
                description: "Tu mensaje aquí, por favor",
                label: "mensaje:",
                "label-for": "input-message",
                "valid-feedback": "¡Gracias!",
                "invalid-feedback": _ctx.floatingInvalidFeedbackMessage,
                state: _ctx.floatingStateMessage
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_textarea, {
                    size: "lg",
                    id: "input-message",
                    type: "textarea",
                    modelValue: _ctx.message,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
                    state: _ctx.floatingStateMessage,
                    trim: "",
                    placeholder: "Mensaje",
                    rows: "6",
                    "no-resize": ""
                  }, null, 8, ["modelValue", "state"])
                ]),
                _: 1
              }, 8, ["invalid-feedback", "state"])
            ]),
            _createVNode(_component_CKEditorVue, {
              modelValue: _ctx.editorData,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editorData) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["onKeydown"])
      ]),
      _: 1
    }),
    _createVNode(_component_b_button, {
      class: "input-form--submit-button mb-3 mt-1",
      onClick: _ctx.handleAddMessage,
      type: "submit",
      pill: ""
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}